import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-error-list',
    templateUrl: './error-list.component.html',
    styleUrls: ['./error-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ErrorListComponent {
    @Input() public errors: string[] = [];
}
